import gql from 'graphql-tag';

export const createTargetTimeRule = gql`
  mutation createTargetTimeRule($input: InputCreateTargetTimeRule!) {
    createTargetTimeRule(input: $input) {
      id
      groupId
      category
      issue
      targetResponseSeconds
      targetCompletionSeconds
      createdAt
      updatedAt
      createdBy
      updatedBy
    }
  }
`;
